<template>
  <v-dialog
    :value="value"
    :max-width="dialogWidth"
    :fullscreen="isMobile()"
    scrollable
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card :height="cardHeight">
      <v-card-title>
        {{  $t('location.location') }}
        <GeofenceResultInfoMenu v-if="infoMenuActive"/>
        <v-spacer/>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-title class="py-2">
        <v-chip
            v-if="locationResult"
            v-show="geofence.length > 0"
            :color="locationResult.color"
            outlined
        >
          {{ this.$tc('location.locationIs',
          this.geofenceResult.name ? 1 : getGeofenceNames().length,{
          geoLocation: locationResult.text,
          geofence: this.geofenceResult.name ? this.geofenceResult.name : getGeofenceNames().map((it) => ' ' + it),
          }) }}
        </v-chip>
      </v-card-title>

      <v-divider/>

      <v-card-text class="pa-2">
        <MapLoader :markers="markers"
                   :geofences="assignmentGeofences()"
                   current-location
                   @update-accuracy="setAccuracy"
                   @update-geofence-result="setGeofenceResult"
        />
      </v-card-text>
      <v-divider/>

      <v-card-actions class="py-3">
        <v-spacer/>
        <p v-html="$t('location.accuracy', { accuracy: accuracy })">
        </p>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

import constants from '@/constants';

import isMobile from '@/mixins/displayAdaptable';
import attachMobileBackButton from '@/mixins/attachMobileBackButton';

import LocationUtil from '@/util/location-util';

import MapLoader from '@/components/MapLoader.vue';
import GeofenceResultInfoMenu from '@/components/GeofenceResultInfoMenu.vue';

import find from 'lodash/find';

export default {
  name: 'CurrentLocationMapDialog',
  components: { GeofenceResultInfoMenu, MapLoader },
  mixins: [attachMobileBackButton, isMobile],
  props: {
    value: Boolean,
  },

  data() {
    return {
      accuracy: '-',
      markers: [
        {
          title: 'Clocking Location',
        },
      ],
      geofenceResult: null,
    };
  },

  computed: {
    ...mapState(['geofence', 'employee']),

    dialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg':
        case 'xl': {
          return '50%';
        }
        default: {
          return '100%';
        }
      }
    },

    cardHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': {
          return '750px';
        }
        default: {
          return '600px';
        }
      }
    },

    locationResult() {
      if (this.geofenceResult && this.geofenceResult.result) {
        if (this.geofenceResult.result === constants.LocationData.GeofenceResult.INSIDE) {
          return {
            color: `${constants.AppColors.SUCCESS} darken-1`,
            text: this.$t(`location.geoLocation.${this.geofenceResult.result}`),
          };
        }
        return {
          color: this.geofenceResult.result === constants.LocationData.GeofenceResult.OUTSIDE
            ? `${constants.AppColors.ERROR} darken-1`
            : `${constants.AppColors.WARN} darken-1`,
          text: this.$t(`location.geoLocation.${this.geofenceResult.result}`),
        };
      }
      return null;
    },

    infoMenuActive() {
      return this.geofenceResult && this.geofenceResult.result
        && (this.geofenceResult.result === constants.LocationData.GeofenceResult.BORDERING_INSIDE
          || this.geofenceResult.result === constants.LocationData.GeofenceResult.BORDERING_OUTSIDE);
    },
  },

  methods: {
    setAccuracy(value) {
      this.accuracy = LocationUtil.getMeasuredAccuracy(value);
    },

    setGeofenceResult(value) {
      this.geofenceResult = value;
    },

    getGeofenceNames() {
      const geofences = this.assignmentGeofences();

      if (geofences) {
        return geofences.flatMap((fence) => fence.name);
      }
      return '';
    },

    assignmentGeofences() {
      let assignmentIds = [];

      if (this.employee.assignments) {
        assignmentIds = this.employee.assignments.flatMap((assignment) => assignment.id);
      }
      let geofences = [];

      assignmentIds.forEach((assignmentId) => {
        const geoFenceAssignments = find(this.geofence, (fence) => fence.assignmentId === assignmentId);

        if (geoFenceAssignments) {
          geofences = geofences.concat(geoFenceAssignments.geofences);
        }
      });

      return geofences;
    },
  },
};
</script>
